/**
 * Runtime config for vision_web.
 *
 * Values are injected into `window.__APP_CONFIG__` at container start by
 * deploy/entrypoint.sh (and, in dev, by the vite middleware in vite.config.js).
 * Every key is required: a missing or empty value throws here at import time so the app
 * fails fast on misconfiguration instead of silently calling an empty origin.
 */

import { REQUIRED_CONFIG_KEYS } from './configKeys';

function loadConfig() {
  const source = globalThis.__APP_CONFIG__ || {};
  const resolved = {};
  const missing = [];

  for (const key of REQUIRED_CONFIG_KEYS) {
    const value = source[key];
    if (typeof value !== 'string' || value.trim() === '') {
      missing.push(key);
      continue;
    }
    resolved[key] = value;
  }

  if (missing.length > 0) {
    throw new Error(`Missing required config: ${missing.join(', ')}`);
  }

  return Object.freeze(resolved);
}

export const config = loadConfig();
